import React, { useCallback, useEffect, useRef, useState } from 'react';
import Chart from 'react-apexcharts';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { ReactComponent as SearchIcon } from '../../../../../assets/icons/ubr_search.svg';
import { Button, Input, Select } from '../../../../../components';
import { defaultOptions_Homologacao } from '../../../../../mocks/data';
import api from '../../../../../services/api';
import getValidationErrors from '../../../../../utils/getValidationErrors';
import { quantidade, periodo } from '../dataFilter';
import { ChartCard, ActionsForm, Container, ContainerFilter } from '../styles';

interface GraficosProps {
  serie?: string;
  periodo?: number;
  quantidade?: number;
  cooperativa?: string;
  descricao?: string;
  categorias?: string;
}

interface PrincipaisCriticasSearch {
  periodo?: number;
  quantidade?: number;
  cooperativa?: string;
  descricao?: string;
  categorias?: string;
}

const Homologação: React.FC = () => {
  let selectedQuantidade = useRef<any>();
  let selectedPeriodo = useRef<any>();
  const formRef = useRef<FormHandles | null>(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [dataHomologacao, setDataHomologacao] = useState<GraficosProps[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [categoriesHomologacao, setCategoriesHomologacao] = useState<string[]>(
    [],
  );
  const [graphConfigHomologacao, setGraphConfigHomologacao] = useState<any>(
    defaultOptions_Homologacao,
  );
  const [seriesHomologacao, setSeriesHomologacao] = useState<any[]>([]);

  const fetchDataHomologacao = useCallback(async () => {
    try {
      const response = await api.get(
        'grafico/quantidadeHomologacao?quantidade=5&periodo=15',
      );
      const dataHomologacao = response.data;
      const categorias = dataHomologacao.map((item: any) => item.cooperativa);
      const series = [
        {
          name: 'Finalizada',
          data: dataHomologacao.map((item: any) => item.quantidadeFinalizada),
          color: '#166649',
        },
        {
          name: 'Pendente',
          data: dataHomologacao.map((item: any) => item.quantidadePendente),
          color: '#ab934b',
        },
      ];
      setSeriesHomologacao(series);
      setCategoriesHomologacao(categorias);
      const Config_Homologacoes = {
        ...graphConfigHomologacao,

        stroke: {
          show: true,
          colors: ['#166649', '#ab934b'],
          width: 2,
          curve: 'smooth',
          lineCap: 'butt',
          dashArray: 0,
        },

        xaxis: { categories: categorias },
        plotOptions: {
          bar: {
            borderRadius: 5,
            columnWidth: '50%',
          },
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            type: 'vertical',
            gradientToColors: undefined,
            shadeIntensity: 0.25,
            inverseColors: true,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 90, 100],
          },
        },
      };

      setGraphConfigHomologacao(Config_Homologacoes);
      setDataHomologacao(dataHomologacao);
    } catch (e) {
      console.error(e);
    }
  }, []);

  useEffect(() => {
    fetchDataHomologacao();
  }, [fetchDataHomologacao]);

  //Filtro Principais Criticas
  const handleFilterPercentualPendencias = async (
    data: PrincipaisCriticasSearch,
  ) => {
    try {
      formRef.current?.setErrors({});

      const schema = Yup.object().shape({
        periodo: Yup.string().required('Este campo é obrigatório!'),
        quantidade: Yup.string().required('Este campo é obrigatório!'),
      });
      await schema.validate(data, {
        abortEarly: false,
      });

      data.quantidade = selectedQuantidade.current;
      data.periodo = selectedPeriodo.current;
      let URL = `/grafico/quantidadeHomologacao?quantidade=${data.quantidade}&periodo=${data.periodo}`;
      URL += data.cooperativa ? `&cooperativa=${data.cooperativa}` : '';
      const response = await api.get(URL);
      const dataHomologacao = response.data;
      const categorias = dataHomologacao.map((item: any) => item.cooperativa);
      const series = [
        {
          name: 'Finalizada',
          data: dataHomologacao.map((item: any) => item.quantidadeFinalizada),
        },
        {
          name: 'Pendente',
          data: dataHomologacao.map((item: any) => item.quantidadePendente),
        },
      ];
      setSeriesHomologacao(series);
      setCategoriesHomologacao(categorias);
      const Config_Homologacoes = {
        ...graphConfigHomologacao,
        xaxis: { categories: categorias },
      };

      setGraphConfigHomologacao(Config_Homologacoes);
      setDataHomologacao(dataHomologacao);
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errorMessages = getValidationErrors(err);
        formRef.current?.setErrors(errorMessages);
        return;
      }
    }
  };

  return (
    <>
      <ChartCard>
        <Container>
          <h2>Quantidade de Homologações por Cooperativa</h2>
          <Form
            className="form-container"
            ref={formRef}
            onSubmit={handleFilterPercentualPendencias}
          >
            <ContainerFilter>
              <Input
                name="cooperativa"
                label="Cooperativa"
                type="text"
                placeholder="0000"
                mask="coop"
              />
              <div className="field-select" style={{ marginLeft: '1rem' }}>
                <Select
                  name={'periodo'}
                  isMulti={false}
                  options={periodo}
                  onChange={option => (selectedPeriodo.current = option.value)}
                  placeholder=" "
                  label="Periodo"
                  width={'100px'}
                />
              </div>
              <div className="field-select">
                <Select
                  name={'quantidade'}
                  isMulti={false}
                  options={quantidade}
                  onChange={option =>
                    (selectedQuantidade.current = option.value)
                  }
                  placeholder=" "
                  label="Quantidade"
                  width={'100px'}
                />
              </div>

              <ActionsForm>
                <Button
                  variant="solid-icon"
                  type={'submit'}
                  style={{ marginRight: '1rem' }}
                  tooltipText={'Pesquisar'}
                >
                  <SearchIcon style={{ width: '26px' }} />
                </Button>
              </ActionsForm>
            </ContainerFilter>
          </Form>

          <Chart
            options={graphConfigHomologacao}
            series={seriesHomologacao}
            type="bar"
            height={350}
          />
        </Container>
      </ChartCard>
    </>
  );
};

export default Homologação;
